import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {skip, take} from 'rxjs/operators';
import {BaseResolverService} from '@abstract/base-resolver.service';
import {PagingApiService} from '@abstract/paging-api.service';

export class PagingResolverService extends BaseResolverService implements Resolve<any> {
    constructor(
        service: PagingApiService,
        router: Router,
    ) {
        super(service, router);
    }

    resolve(snapshot: ActivatedRouteSnapshot) {
        const service: PagingApiService = this.resolverService as PagingApiService;

        if (service.addFiltersToUrl && Object.keys(snapshot.queryParams).length) {
            service.parseQueryParams(snapshot.queryParams);
        }

        service.updateItems();

        return service.items$.pipe(
            skip(1),
            take(1)
        );
    }
}
